<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Ayar"
    }
</script>

<style scoped>

</style>